export default
{
  nav: {
    'shipping-locale': 'Lingua',
  },
  titles: {
    default: 'Salvi Music Online Store',
    profile: 'Il tuo profilo',
    orders: 'I tuoi ordini',
    addresses: 'I tuoi indirizzi',
    coupons: 'I tuoi buoni',
    configurator: 'Configuratore',
    checkout: 'Pagamento',
  },
  profile: {
    profile: 'Il mio account',
    greeting: 'Ciao',
    orders: 'I miei ordini',
    data: 'I miei dati',
    addresses: 'I miei indirizzi',
    coupons: 'Buoni regalo',
    logout: 'Esci',
  },
  userData: {
    myData: 'I MIEI DATI',
    complete: 'Completa il tuo profilo',
    private: 'Privato',
    company: 'Azienda',
    birthday: 'Data di nascita',
    job: 'Professione',
    vat: 'Partita IVA',
    language: 'Lingua',
    changeLanguage: 'Cambia lingua di default',
    myHarps: 'LE MIE ARPE',
    addHarp: 'Aggiungi arpa',
    newHarp: 'Nuova arpa',
    chooseHarp: 'Scegli arpa',
    accessData: 'DATI DI ACCESSO',
    save: 'Salva',
    cancel: 'Annulla',
    cannotChange: 'Non puoi cambiare tipo di utente perché hai già degli ordini a tuo nome.',
    createNew: 'Crea un nuovo profilo per effettuare ordini per un altro tipo di utente.',
    haveHarps: "Hai un'arpa o più?",
    addHarps: 'Aggiungile qui per settare il tuo configuratore',
    close: 'Chiudi',
    dateFormatPlaceholder: 'gg/mm/aaaa',
    dateFormat: 'dd/MM/yyyy',
  },
  addresses: {
    sameAs: "Uguale all'indirizzo di fatturazione",
    addMore: 'Aggiungi più indirizzi di spedizione',
    areYouSure: 'Sei sicuro di voler eliminare questo indirizzo?',
    cancel: 'Annulla',
    delete: 'Elimina',
    edit: 'Modifica indirizzo',
    add: 'Aggiungi indirizzo',
  },
  addressForm: {
    firstname: 'Nome',
    lastname: 'Cognome',
    co: 'C/O',
    street: 'Via/Piazza',
    number: 'Numero',
    postcode: 'CAP',
    city: 'Città',
    state: 'Provincia',
    country: 'Nazione',
    phone: 'Telefono',
    note: 'Note',
    save: 'Salva',
    taxNumber: 'Codice Fiscale',
    taxNumberBracket: '(obbligatorio solo per i residenti in Italia)',
    taxNumberMessage: "Il codice fiscale non corrisponde al codice di una persona fisica. Se siete un'azienda privata si prega di contattare l'assistenza via mail.",
  },
  password: {
    changePassword: 'Cambia password',
    old: 'Vecchia password',
    new: 'Nuova password',
    newConfirm: 'Conferma nuova password',
    savePassword: 'Salva nuova password',
  },
  payments: {
    stripe: 'Carta di Credito',
    paypal: 'PayPal',
    'paypal-msg': 'Stai per essere reindirizzato sul sito di Paypal',
    'stripe-msg': 'Stiamo eseguendo il pagamento...',
    'sepa-msg': 'Stiamo eseguendo il pagamento...',
    'sofort-msg': 'Stai per essere reindirizzato sul sito di Sofort',
    sepa: 'Sepa Direct Debit',
    sofort: 'Sofort Banking',
    cash: 'Contrassegno',
  },
  shipping: {
    'shipping-to': 'Spedizione:',
    express: 'Espressa',
    standard: 'Standard',
    waiter: 'Aspetti',
  },
  checkout: {
    header: 'Pagamento',
    'billing-address': 'Indirizzo di Fatturazione',
    'shipping-address': 'Indirizzo di Spedizione',
    'shipping-addresses': 'Indirizzi di Spedizione',
    'first-name': 'Nome',
    'last-name': 'Cognome',
    email: 'Email',
    phone: 'Numero Telefomo',
    country: 'Seleziona una Nazione',
    city: 'Città',
    address: 'Via',
    no: 'Num. Civico',
    zip: 'CAP',
    'shipping-to': 'Spedire a:',
    'payment-method': 'Metodo di Pagamento:',
    summary: 'Riepilogo:',
    'order-btn': "Completa l'ordine",
    workingOn: 'Ordine in attesa di creazione',
    processing: 'Ci sto lavorando ...',
    'order-placed': 'Ordine Piazzato',
    selectAddress: 'Seleziona un indirizzo di spedizione:',
    changeAddress: 'Cambia indirizzo selezionato',
    addAddress: 'Aggiungi indirizzo',
    comeBack: 'Torna al pagamento',
    'delay-message': "Se scegli questo metodo di pagamento, i tempi di consegna potrebbero essere più lunghi. Prima di evadere l'ordine attendiamo la notifica di avvenuto pagamento (da 2 a 6 giorni).",
    'cash-message1': 'Questo metodo di pagamento comporta una commissione di',
    'cash-message2': "in aggiunta al totale dell'ordine.",
    commission: 'Commissione',
    coupon: 'Codice sconto',
    'discounted-total': 'Totale scontato',
    'discounted-subtotal': 'Subtotale scontato',
  },
  locale: {
    language: 'Lingua:',
  },
  catalog: {
    'view-all': 'Vedi tutti',
    'search-acc': 'Cerca Accessori',
    'search-str': 'Cerca Corde',
    octaves: 'Ottave',
    strings: 'Corde',
    brands: 'Brands',
    str: 'Corde',
    acc: 'Accessori',
    subcategory: 'Sottocategoria',
    brand: 'Brand',
  },
  menu: {
    'configurator-string': 'Configuratore di corde',
    search: 'Cerca',
    account: 'Il mio Account',
    cart: 'Carrello',
    'shipping-locale': 'Cambia Lingua',
  },
  login: {
    enter: 'Accedi',
    'pw-forgot': 'Password dimenticata?',
    new: 'Nuovo Cliente?',
    register: 'Registrati',
    verify: 'Per favore, verifica il tuo indirizzo email',
    welcome: 'Bentornato, ',
    logout: 'Esci',
  },
  signin: {
    title: 'Registrati o accedi a Salvi Music',
    register: 'Registrati',
    login: 'Accedi',
    firstname: 'Nome',
    lastname: 'Cognome',
    email: 'Email',
    password: 'Password',
    confirmPassword: 'Conferma password',
    receive: "Non hai ricevuto l'email?",
    resend: 'Rimanda email',
    vatsMessage: 'Se volete registrarvi su questo sito come persone giuridiche (scuole, associazioni, titolari di paritita iva) contattateci scrivendo a questo indirizzo: ',
  },
  carousel: {
    title1: 'PROVA IL NUOVO CONFIGURATORE DI CORDE',
    title2: 'TUTTI GLI ACCESSORI PER LA TUA ARPA',
    discover: 'Scopri',
  },
  product: {
    vat: 'Iva inclusa, spedizione esclusa',
    shipping: 'Spedizione Gratuita',
    payment: 'Pagamento sicuro',
    returns: 'Resi e Rimborsi',
    details: 'Dettagli Prodotto',
    'shop-by': 'Acquista per',
    brand: 'Marchio',
    price: 'Prezzo',
    shop: 'Acquista',
    strings: 'Corde',
    string: 'Corde',
    accessories: 'Accessori',
    delivery: 'Spedizione e Consegna',
    material: 'Materiale:',
    octave: 'Ottava:',
    note: 'Nota:',
    quantity: 'Quantità:',
    'orders-over': 'Per ordini superiori a 150€',
    'free-delivery': "Consegna Gratuita per acquisti superiori a 150€. La spedizione gratuita si applica automaticamente non appena viene raggiunto l'importo.",
    addToCart: 'Aggiungi al carrello',
    addedToCart: 'Prodotto aggiunto al carrello',
    alt: 'Immagine per',
    widget: 'Scheda prodotto',
    addToCartOctave: "Aggiungi al carrello l'ottava",
    addToCartLayout: 'Aggiungi al carrello la cordiera',
    searchingStrings: 'Stai cercando tra le corde: ',
    outOfStock: 'Esaurito',
    noVat: 'Iva esclusa, spedizione esclusa',
    notAvailable: 'Attualmente non disponibile',
    categories: 'Categorie',
    sheet: 'Spartiti',
    cd: 'Recordings & CD',
    onRequest: 'Richiedi (via email)',
    onRequestMessage: 'Richiedi via email questo articolo con un semplice click. Al momento non è disponibile in magazzino, i tempi di consegna sono dilatati (circa 2 settimane).',
    onRequestAreYouSending: 'Stai inviando una richiesta di ordine per il prodotto:',
  },
  string: {
    family: 'famiglia:',
    material: 'materiale:',
    octave: 'ottava:',
    note: 'nota:',
  },
  orders: {
    number: 'numero ordine',
    date: 'data ordine',
    amount: 'importo',
    status: 'stato ordine',
    'status-in_work': 'In Lavorazione',
    'status-shipped': 'Spedito',
    'status-new': 'Nuovo',
    'status-registered': 'Registrato',
    'status-pending': 'In sospeso',
    'status-failed_payment': 'Pagamento fallito',
  },
  order: {
    details: 'dettaglio dell\'ordine',
    'invoice-link': 'Vedi fattura',
    'status-processed': '1. Processato',
    'status-transit': '2. In transito',
    'status-delivered': '3. Consegnato',
    number: 'Numero ordine',
    date: 'Data ordine',
    'billing-address': 'Dati di fatturazione',
    'shipping-address': 'Indirizzo di spedizione',
    'shipping-method': 'Modalità di trasporto',
    'payment-method': 'Metodo di pagamento',
    summary: 'Riepilogo',
    description: 'Descrizione',
    code: 'Codice',
    product: 'Articolo',
    qty: 'Quantità',
    amount: 'Importo',
    back: 'Torna',
    subtotal: 'Subtotale',
    shipping: 'Spedizione',
    total: 'Totale',
    'inc-vat': 'IVA incl.',
    'tracking-info': 'Informazioni tracking',
    'tracking-sentence': 'Controlla l\'avanzamento della tua spedizione ',
    'tracking-here': 'qui',
    pending: 'Ordine in attesa di pagamento.',
    pay: 'Paga',
    message: 'Se il pagamento non verrà effettuato entro una settimana, questo ordine verrà eliminato.',
    noVat: 'IVA escl.',
    waitingConfirm: 'In attesa di conferma del pagamento',
  },
  configurator: {
    title: 'CONFIGURATORE DI CORDE',
    subtitle: 'Il modo più facile e veloce per trovare la corda giusta',
    chooseHarp: "Scegli un'arpa",
    selectOctave: 'Scegli ottava',
    selectNote: 'Scegli nota',
    selectMaterial: 'Scegli materiale',
    strings: 'Corde',
    seeMore: 'Vedi più arpe',
    seeYours: 'Vedi le tue arpe',
    octave: 'Ottava',
    note: 'Nota',
    description: 'Descrizione',
    price: 'Prezzo',
    reset: 'Resetta il configuratore',
    lever: 'Arpe lever',
    pedal: 'Arpe pedal',
    electric: 'elettriche',
    electroacustic: 'elettroacustiche',
    'professional lever': 'Professional lever',
    'student lever': 'Student lever',
    premium: 'Premium',
    'professional pedal': 'Professional pedal',
    'student pedal': 'Student pedal',
    'lever gut': 'Budello Lever',
    'pedal gut': 'Budello Pedal',
    silkgut: 'Silkgut',
    biocarbon: 'BioCarbon',
    KF: 'Carbon',
    workInProgress: 'Il configuratore di corde è work in progress',
    comeBack: 'Se non trovi la configurazione della tua arpa, prova a tornare tra qualche giorno.',
  },
  footer: {
    terms: 'Termini e Condizioni',
    shipping: 'Spedizione e Pagamenti',
    about: 'Su di noi',
    shop: 'Negozio',
    contact: 'Contatti',
    newsletter: 'Iscriviti alla newsletter',
    signup: 'Registrati',
    'customer-service': 'Assistenza clienti',
    cookie: 'Informativa sulla Privacy e Cookie',
    'privacy-newsletter': "Letta la Privacy Policy presto il mio consenso per l'invio di comunicazioni informative e promozionali, inclusa la newsletter.",
    'cookie-banner': '🍪 Questo sito web utilizza i cookie. Per ulteriori informazioni clicca',
    'cookie-button': 'Ho capito',
    here: 'qui',
    logos: 'loghi',
    socialLogos: 'loghi social networks',
    paymentLogos: 'loghi pagamenti',
    email: 'Email',
    newsletterTitle: 'Newsletter',
    imprint: 'Informazioni legali',
  },
  error: {
    404: 'Errore 404',
    page: 'UH OH! Ti sei perso?',
    phrase: 'La pagina che stai cercando non esiste. Come sei arrivata/o qui è un mistero. Ma puoi cliccare il pulsante qui sotto per tornare alla pagina iniziale.',
    503: 'Torniamo presto!',
    'phrase-503': 'Il sito è momentaneamente in manutenzione, ma torneremo online presto. Riprova più tardi!',
  },
  cart: {
    cart: 'Carrello',
    clear: 'Svuota carrello',
    total: 'Totale',
    subtotal: 'Subtotale',
    shippingCalculate: 'Spedizione calcolata al momento del pagamento',
    shipping: 'spedizione',
    vat: 'Inclusa IVA',
    checkout: 'Pagamento',
    emptyCart: 'Il carrello è vuoto.',
    noVat: 'Esclusa IVA',
    shippingNational: 'Prezzo spedizione nazionale',
    shippingAbroad: 'Prezzo spedizione internazionale',
    heavyShipping: 'Il prezzo di spedizione varia in base al peso degli articoli selezionati',
  },
  notifications: {
    error: 'Si è verificato un errore:',
    failedReadingProduct: 'Lettura prodotto selezionato fallita:',
    credentialsInvalid: 'Le credenziali inserite non sono valide.',
    successfulLogin: 'Login effettuato con successo!',
    noMoreLoggedIn: 'Non sei più loggato!',
    changeLocale: 'Errore nel settaggio della lingua:',
    harpsReading: 'Lettura arpe fallita',
    updateLocale: 'Lingua aggiornata con successo',
    saveAddress: 'Indirizzo salvato con successo',
    editAddress: 'Indirizzo aggiornato con successo',
    removeAddress: 'Indirizzo rimosso con successo',
    addHarp: 'Arpa aggiunta con successo',
    removeHarp: 'Arpa rimossa con successo',
    updatePassword: 'Password aggiornata con successo',
    registration: 'Registrazione effettuata con successo!',
    contact: 'Email inviata con successo a info@salvimusic.de',
    chooseHarp: "Selezionare un'arpa",
    errorTryAgain: 'Si è verificato un errore. Si prega di riprovare',
    expiredSession: "Sessione scaduta. Effettuare l'accesso",
    errorReload: 'Si è verificato un errore. Si prega di ricaricare la pagina',
    errorPayment: 'Si è verificato un errore nel pagamento, si prega di riprovare',
    whyDiscount: 'Hai diritto a questo sconto in qualità di ',
    outOfStockFirst: 'Il prodotto',
    outOfStockSecond: 'è stato rimosso dal carrello perché attualmente esaurito.',
    noStringsLayout: 'La configurazione ricercata non è ancora disponibile',
    emailSendAgain: 'Una nuova email è stata inviata',
    newsletterAccept: "Si prega di accettare l'informativa sulla privacy",
    newsletterSend: "Ti abbiamo inviato un'email per confermare l'iscrizione alla newsletter",
    onRequestEmail: 'Email di richiesta inviata',
  },
  contacts: {
    title: 'Contatti',
    'opening-hours': 'Orari di apertura:',
    showroomPhone: 'Tel.:',
    showroomEmail: 'Email:',
    firstShowroom: {
      name: 'Showroom di Remagen',
      address: 'Mainzer Straße, 28 - 53424 Remagen',
      time: 'Orari di apertura: dal lunedì al venerdì dalle 9:00 alle 17:00',
      phone: 'Tel.: 02228.8093',
      email: 'Email: info@salvimusic.de',
    },
    secondShowroom: {
      name: 'Showroom di Berlino',
      address: 'Schloßstraße, 66 - 14059 Berlino',
      time: 'Orari di apertura: dal lunedì al venerdì dalle 9:30 alle 17:30',
      phone: 'Tel.: 030.37025222',
      email: 'Email: info@salvimusic.de',
    },
    contactUs: 'Contattaci',
    firstname: 'Nome',
    lastname: 'Cognome',
    email: 'Email',
    phone: 'Telefono',
    message: 'Messaggio',
    send: 'Invia',
  },
  paginate: {
    previous: 'Precedente',
    next: 'Successivo',
  },
  stripe: {
    data: 'Dati pagamento',
    holder: 'Intestatario carta',
    save: 'Salva Metodo di Pagamento',
    add: 'Aggiungi una carta',
    enterPaymentMethod: 'Selezionare un metodo di pagamento',
    authRequired: 'Necessaria autenticazione per autorizzare il pagamento',
    expiry: 'Scadenza:',
    mine: 'I miei metodi di pagamento',
  },
  cards: {
    cards: 'Le mie carte',
    areYouSure: 'Sei sicuro di voler eliminare questo metodo di pagamento?',
    irreversible: 'Operazione irreversibile',
    delete: 'Elimina',
    cancel: 'Annulla',
    expired: 'SCADUTA!',
    last: 'ultimo metodo di pagamento utilizzato',
    seeAll: 'Vedi tutte le carte',
    close: 'Chiudi',
  },
  iban: {
    seeAll: 'Vedi tutti gli iban',
    close: 'Chiudi',
    add: 'Aggiungi un iban',
    save: 'Salva iban',
  },
  input: {
    fillField: 'Compila questo campo',
  },
  metaDescriptions: {
    homepage: "Benvenuti su Salvi Music Online SHOP, la vostra destinazione d'acquisto online che offre tutti i tipi di accessori e corde per la vostra arpa. Qualità e precisione è ciò che ci caratterizza.",
    about: 'Salvi Music Online SHOP accompagna con impegno, servizio e conoscenza tutti gli arpisti, professionisti e non, nella selezione di arpe levette e pedali, spartiti, corde e accessori e molto altro…',
    configurator: 'Qualsiasi corda per la vostra arpa! Con il nostro sistema veloce e ottimale, il configuratore vi proporrà tutto ciò di cui avete bisogno con un semplice click.',
    categoryCatalogs: 'Nel nostro catalogo troverete tutte le corde, per arpe lever e pedal, delle migliori marche Bow Brand, Pirastro, Sipario, e tutti gli accessori per la vostra arpa, cappe da trasporto, carrelli, spartiti, sgabelli, leggii, chiavi per accordare e altro ancora...',
    brandCatalogs: 'Offriamo un catalogo completo per tutta le linee Salvi Harps, Lyon & Healy, BowBrand e Sipario. Clicca qui per scoprire di più...',
    account: 'Sfruttate al meglio le opzioni del vostro account personale: controllate lo stato del vostro ordine, utilizzate coupon, salvate e modificate i vostri dati.',
    orders: 'Effettua con facilità il tuo ordine, controlla lo stato in qualsiasi momento con un semplice click...',
    addresses: 'Indirizzo di fatturazione e spedizione, gestisci facilmente i tuoi indirizzi, aggiungi, modifica e cancella…',
    coupons: 'Controlla qui i tuoi coupon, sconti sorprendenti solo per te!',
    checkout: 'Il vostro pagamento al momento del checkout viene effettuato in tutta sicurezza scegliendo la modalità che preferite! Scopri di più…',
    singleOrder: 'In I miei ordini potrai visualizzare il riepilogo del tuo ordine, lo stato della spedizione e i dettagli, fornendo semplicemente i tuoi dati di registrazione.',
    terms: 'Visualizza i termini e le condizioni complete per gli acquisti su Salvi Music Online SHOP, incluse informazioni sul pagamento, la consegna, i resi e altro ancora.',
    return: 'Siamo sempre a disposizione per cambiare o rimborsare qualsiasi articolo acquistato entro i 30 giorni dalla data di acquisto. Per saperne di più…',
    shipping: 'Non è mai stato così conveniente! Solo 2 EUR a spedizione, se invece il tuo ordine supera 150 EUR la spedizione è gratuita',
    contacts: 'Hai una domanda o cerchi supporto? Mettiti subito in contatto con noi. In tutta Europa, a portata di mano. Trova qui i nostri showroom e i contatti per la migliore assistenza.',
  },
  productAttributes: {
    material: 'Materiale',
    octave: 'Ottava',
    note: 'Nota',
    silkgut: 'Silkgut',
    'silkgut copper': 'Silkgut Copper',
    biocarbon: 'BioCarbon',
    kf: 'KF',
    'lever gut': 'Budello lever',
    'pedal gut': 'Budello pedal',
    'lever wire': 'Metallo lever',
    'pedal wire': 'Metallo pedal',
    'lever nylon': 'Nylon lever',
    'pedal nylon': 'Nylon pedal',
    'polyester/polyurethane': 'Poliestere/Poliuretano',
    velvet: 'Velluto',
    satin: 'Raso',
    'eco fabric': 'Tessuto Eco',
    'steel/rubber': 'Acciaio / Gomma',
    leather: 'Pelle',
    cordura: 'Cordura',
    wood: 'Legno',
    steel: 'Acciaio',
    polyester: 'Poliestere',
    'leather, nylon': 'Pelle, nylon',
    wire: 'Metallo',
    alluminium: 'Alluminio',
    'nylon/polyurethane': 'Nylon/Poliuretano',
    'cotton/vinyl': 'Cotone / Vinile',
    felt: 'Feltro',
  },
  coupons: {
    apply: 'Applica',
    validCode: 'codice valido',
    noSelected: 'Nessun coupon selezionato',
    hasACoupon: 'Hai un codice sconto?',
    invalid: 'Il codice sconto inserito non è valido o è già stato utilizzato',
    code: 'Codice',
    description: 'Descrizione',
    value: 'Valore',
    uses: 'Numero di utilizzi',
    expiration: 'Scadenza',
    exhaustion: 'fino ad esaurimento',
    used: 'Codice sconto utilizzato',
    subtotalWithoutCoupon: 'Subtotale senza sconto',
    subtotalDiscounted: 'Subtotale scontato',
    writeCoupon: 'Scrivi il codice sconto:',
    chooseCoupon: 'Oppure seleziona uno tra i tuoi buoni sconto:',
    expired: 'Scaduto',
    noCoupons: 'Al momento non sono presenti buoni regalo.',
  },
  filters: {
    clear: 'Cancella filtri',
    brand: 'Marchio',
    subcategory: 'Sottocategoria',
    noProducts: 'Non sono presenti prodotti con queste caratteristiche.',
    noComposers: 'Non sono presenti compositori con questa iniziale.',
    searchComposer: 'Cerca compositore',
  },
};
